import React, { Component } from 'react';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import Row from 'app/shared/core/Row';
import Text from 'app/shared/core/Text';
import Linker from 'app/shared/modules/Linker';
import IconFairHousing from 'images/icons/income-restricted-new.svg';
import {
  fairHousingCSS,
  fairHousingDisplayBlockCSS,
  fairHousingIconContainerCSS,
  fairHousingIconCSS,
  fairHousingInfoCSS,
} from 'app/shared/modules/HomeHub/styles';
import type { RootReduxState } from 'app/shared/flux/reducers';

type FairHousingProps = {
  isNewYorkGeoIp: boolean;
  isNewYorkRecentSearch: boolean;
};

class FairHousing extends Component<FairHousingProps> {
  render() {
    const { isNewYorkGeoIp, isNewYorkRecentSearch } = this.props;
    if (!isNewYorkGeoIp && !isNewYorkRecentSearch) {
      return <article className={fairHousingCSS} aria-hidden="true" />;
    }
    return (
      <article className={fairHousingCSS}>
        <div className={fairHousingDisplayBlockCSS}>
          <Text htmlTag="h2" size="xl">
            <strong>New York + Fair Housing</strong>
          </Text>
          <hr />
        </div>
        <Row>
          <div className={fairHousingDisplayBlockCSS}>
            <div className={fairHousingIconContainerCSS}>
              <img className={fairHousingIconCSS} src={IconFairHousing} alt="" />
            </div>
            <div className={fairHousingInfoCSS}>
              <Linker
                linkType="underline"
                target="_blank"
                to="https://www.dos.ny.gov/licensing/docs/FairHousingNotice_new.pdf "
              >
                <Text size="md">Learn about unlawful housing discrimination.</Text>
              </Linker>
            </div>
          </div>
        </Row>
      </article>
    );
  }
}

const mapStateToProps = (state: RootReduxState) => {
  return {
    isNewYorkGeoIp: !isEmpty(state.geolocation.area) && (state.geolocation.area as { state?: string }).state === 'NY',
    isNewYorkRecentSearch:
      !isEmpty(state.user.search.recent.areaInfo) &&
      (state.user.search.recent.areaInfo as { state?: string }).state === 'NY',
  };
};
export default connect(mapStateToProps)(FairHousing);
